import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import Snackbar from '@mui/material/Snackbar';
import Typography from '@mui/material/Typography';
import styled from '@mui/material/styles/styled';
import { SnackType } from '@/features/snacks/enums/SnackType';
import { getSnackBackgroundColor } from '@/features/snacks/utils/getSnackBackgroundColor';
import { getSnackBorderColor } from '@/features/snacks/utils/getSnackBorderColor';
import { getSnackCloseIconColor } from '@/features/snacks/utils/getSnackCloseIconColor';
import { getSnackTextColor } from '@/features/snacks/utils/getSnackTextColor';

export const SnacksSnackbar = styled(Snackbar)`
  width: 100%;
  pointer-events: none;
`;

export const SnacksSnackbarOuterWrapper = styled('div')<{ type: SnackType }>(({ type, theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  maxWidth: '453px',
  padding: '8px 16px',
  border: 'solid 1px',
  borderRadius: '4px',
  borderColor: getSnackBorderColor(theme, type),
  backgroundColor: getSnackBackgroundColor(theme, type),
  pointerEvents: 'all',
  gap: 8,
  alignItems: 'flex-start',
}));

export const SnacksSnackbarInnerWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: calc(100% - 16px);
`;

export const SnacksSnackbarTitleText = styled(Typography)<{ type: SnackType }>(({ type, theme }) => ({
  marginBottom: '2px',
  color: getSnackTextColor(theme, type),
  wordBreak: 'break-word',
}));

export const SnacksSnackbarContentText = styled(Typography)<{ type: SnackType }>(({ type, theme }) => ({
  color: getSnackTextColor(theme, type),
  wordBreak: 'break-word',
}));

export const SnacksSnackbarCloseIcon = styled(CloseOutlinedIcon)<{ type: SnackType }>(({ type, theme }) => ({
  cursor: 'pointer',
  width: '16px',
  height: '16px',
  marginTop: '4px',
  fill: getSnackCloseIconColor(theme, type),
}));
